import { useEffect, useState } from 'react';
import { websocketService } from '../services/websocket.service';

interface UseWebSocketOptions {
  projectId: string;
  onMessage?: (type: string, data: unknown) => void;
}

const SANDBOX_EVENTS = [
  'preview_update',
  'sandbox_building',
  'sandbox_log',
  'sandbox_running',
  'sandbox_error',
  'sandbox_stopped',
  'generation_error',
  'message_created',
];

export function useWebSocket({ projectId, onMessage }: UseWebSocketOptions) {
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    websocketService.connect(projectId);
    setIsConnected(true);

    const unsubs: (() => void)[] = [];
    if (onMessage) {
      for (const event of SANDBOX_EVENTS) {
        unsubs.push(
          websocketService.subscribe(event, (data) => onMessage(event, data))
        );
      }
    }

    return () => {
      unsubs.forEach((fn) => fn());
      websocketService.disconnect();
      setIsConnected(false);
    };
  }, [projectId, onMessage]);

  return {
    isConnected,
    send: (data: unknown) => websocketService.send(data),
  };
}
